
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { NavBar } from '@/modules/common/components/__deprecated__/NavBar';
import { CloseButton } from '@/modules/common/components/buttons';
import {
  GetOrderQuery,
  GetOrderDocument,
  ETradeOrderStatus
} from '@/modules/common/services/graphql/server/server.sdk';
import { ApolloQueryResult } from '@apollo/client';
import {
  Row,
  RoundedIcon,
  BaseModal,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    BaseModal,
    NavBar,
    CloseButton,
    LoaderIndicator,
    Row,
    RoundedIcon
  }
})
export default class DepositByBarCodeModal extends Vue {
  @Prop({ type: String, required: true })
  private id!: string;

  @Prop({ type: Boolean, default: false })
  private isOpen!: boolean;

  private isLoading = true;
  private NebraskaColors = NebraskaColors;
  private order?: any;

  private async beforeMount() {
    await this.loadOrder();
  }

  private get isFilled() {
    return this.order.status.value === ETradeOrderStatus.Filled;
  }

  private get isRejected() {
    return this.order.status.value === ETradeOrderStatus.Rejected;
  }

  @Watch('id')
  private async loadOrder() {
    try {
      if (this.id) {
        const { data }: ApolloQueryResult<GetOrderQuery> =
          await this.$apollo.query({
            query: GetOrderDocument,
            variables: {
              orderId: this.id
            }
          });

        this.order = data.trade!.order;
        this.isLoading = false;
      }
    } catch (e) {
      this.order = undefined;
      this.isLoading = false;
    }
  }
}
